import { handleActions } from 'redux-actions';
import { NOT_REQUESTED, REQUESTED, SUCCEEDED, FAILED } from 'forms-utils-lib/RequestState';
import { REQUEST_HUB_USERS, RECEIVE_HUB_USERS, FAIL_GETTING_HUB_USERS } from 'ui-forms-editor-automation-lib/actions/fetchHubUsers';
export const INITIAL_STATE = {
  users: [],
  requestState: NOT_REQUESTED
};
export default handleActions({
  [REQUEST_HUB_USERS]: state => Object.assign({}, state, {
    requestState: REQUESTED
  }),
  [RECEIVE_HUB_USERS]: (_, {
    payload
  }) => ({
    users: payload,
    requestState: SUCCEEDED
  }),
  [FAIL_GETTING_HUB_USERS]: state => Object.assign({}, state, {
    requestState: FAILED
  })
}, INITIAL_STATE);